const defaultDate = new Date(new Date().setHours(2))
defaultDate.setMinutes(0)
defaultDate.setSeconds(0)

const localState = {
    data: {},
    master: null,
    date: null,
    updateMap: false,
    view: 'all',
    id: '',
    service: 'all',
    master_id: '23',
    showOrderMapWindow: false,
}

const actions = {
    async getMapData({
        state,
        commit,
    }, type) {
        try {
            const response = await this.$api.specialists.fetchMap({
                type,
            })
            state.data = response.data.data

            commit('setMapView', 'all')
            commit('setMapId', '')

            return response.data.data
        } catch (err) {
            console.log(err)
        }
    },

    async getMadDataById({
        state,
        commit,
        dispatch,
    }, {
        id,
        type,
    }) {
        try {
            if (id === 'all') {
                dispatch('getMapData', type)
                return
            }

            const checkData = state.date || defaultDate
            const date = new Date(checkData).getTime() / 1000

            const response = await this.$api.specialists.fetchMapById({
                id,
                type,
                query: `?date=${date}`,
            })
            commit('setMaster', response.data.data)
            commit('setMapUpdate', true)
            commit('setMapView', 'master')
            commit('setMapId', id)
        } catch (err) {
            console.log(err)
        }
    },

    fetchMap({
        state,
        dispatch,
    }, {
        type,
    }) {
        dispatch('getMadDataById', {
            type,
            id: state.id,
        })
    },

    async currentMaster(_, {
        type,
        id,
    }) {
        try {
            const response = await this.$api.specialists.fetchMap({
                type,
            })

            const master = await response.data.data.filter((e) => {
                if (e.master.master_id === id) {
                    return e
                }
            })

            return master[0]
        } catch (err) {
            console.log(err)
        }
    },
}
const mutations = {
    setMaster: (state, v) => {
        state.master = v
    },
    setMapDate: (state, v) => {
        state.date = v
    },
    setMapUpdate: (state, v) => {
        state.updateMap = v
    },
    setMapView: (state, v) => {
        state.view = v
    },
    setMapId: (state, v) => {
        state.id = v
    },
    setMapService: (state, v) => {
        state.service = v
    },
    setOrderMapWindow: (state, v) => {
        state.showOrderMapWindow = v
    },
}
const getters = {
    mapDateGetters: (state) => state.date,
    mapUpdateGetters: (state) => state.updateMap,
    mapMasterGetters: (state) => state.master,
    mapViewGetters: (state) => state.view,
    mapServiceGetters: (state) => state.service,
    mapIdGetters: (state) => state.id,
    showOrderMapWindowGetters: (state) => state.showOrderMapWindow,
}

export default {
    state: localState,
    getters,
    actions,
    mutations,
}
